var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:_vm.classes,attrs:{"role":"alert"}},[_c('div',{staticClass:"alert__icon"},[_c('img',{attrs:{"src":'/images/icons/' + _vm.type + '.svg'}})]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }